import React, { useState, useEffect } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import qs from 'querystringify';
import { useStoreState } from 'easy-peasy';

import client from '../../../utils/apolloClient';
import Layout from '../../../components/global/Layout';
import Header from './Header';
import Search from './Search';
import ListItem from './ListItem';
import {
  Loading,
  Pagination,
  Table,
  Box,
  // CustomInput,
} from '../../../components/elements';

const usersQuery = gql`
  query search_stripe_block_users($input: SearchInput) {
    search_stripe_block_users(input: $input) {
      stripe_block_user_listing {
        stripe_block_user_id
        user_id
        first_name
        last_name
        email
        phone_numbers
        device_ids
        stripe_block_reason
      }
      total_pages
      total_size
    }
  }
`;

const BlockUsers = ({ location, history }) => {
  const routeState = qs.parse(location.search);
  const { userId } = useStoreState(state => state.auth);
  const {
    login,
    firstName,
    displayName,
    status,
    page,
    deviceId,
    phoneNumber,
  } = routeState;

  const loginFilter = login || '';
  const firstNameFilter = firstName || '';
  const displayNameFilter = displayName || '';
  const statusFilter = status || 'ACTIVE';
  const deviceIdFilter = deviceId || '';
  const phoneNumberFilter = phoneNumber || '';

  const currentPage = parseInt(page, 10) - 1 >= 0 ? parseInt(page, 10) - 1 : 0;

  const [userData, setUserData] = useState([]);

  const [sort, setSort] = useState('FIRSTNAME_DESC');
  const [firstNameSort, setFirstNameSort] = useState('AES');
  const [emailSort, setEmailSort] = useState('AES');

  const [pageCount, setPageCount] = useState(0);
  const [totalElements, setTotalElements] = useState();

  const [listSize] = useState(20);

  const input = {};
  const user_filter = { status: statusFilter, role_not_exist: true };
  Object.assign(
    user_filter,
    firstNameFilter !== '' && { full_name: firstNameFilter },
    displayNameFilter !== '' && { display_name: displayNameFilter },
  );

  const stripe_block_user_filter = {};
  Object.assign(
    stripe_block_user_filter,
    loginFilter !== '' && { email_id: loginFilter },
    phoneNumberFilter !== '' && { phone_number: phoneNumberFilter },
    deviceIdFilter !== '' && { device_id: deviceIdFilter },
  );

  Object.assign(
    input,
    { sort },
    { user_id: userId },
    { from: currentPage * listSize, size: listSize },
    {
      filter: {
        user_filter,
        stripe_block_user_filter,
      },
    },
  );
  return (
    <Layout>
      <Header />
      <Box>
        <Search
          status={statusFilter}
          login={loginFilter}
          firstName={firstNameFilter}
          displayName={displayNameFilter}
          deviceId={deviceIdFilter}
          phoneNumber={phoneNumberFilter}
          history={history}
          routeState={routeState}
        />
        <br />
        {totalElements > 0 && (
          <Pagination
            pageFrom={currentPage * listSize}
            pageCount={pageCount}
            listSize={listSize}
            totalElements={totalElements}
            currentPage={currentPage}
            handlePageClick={value =>
              history.push(
                `/block-users${qs.stringify(
                  {
                    ...routeState,
                    page: value.selected + 1,
                  },
                  true,
                )}`,
              )
            }
          />
        )}
        <Table>
          <thead>
            <tr>
              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setEmailSort(emailSort === 'AES' ? 'DES' : 'AES');
                        setSort(
                          emailSort === 'AES' ? 'EMAIL_DESC' : 'EMAIL_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          emailSort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up'
                        }
                      />
                    </a>{' '}
                    Login
                  </span>
                  {/* <br />
                <CustomInput /> */}
                </div>
              </th>
              <th>
                <div>
                  <span>
                    <a
                      onClick={() => {
                        setFirstNameSort(
                          firstNameSort === 'AES' ? 'DES' : 'AES',
                        );
                        setSort(
                          firstNameSort === 'AES'
                            ? 'FIRSTNAME_DESC'
                            : 'FIRSTNAME_ASC',
                        );
                      }}
                    >
                      <i
                        className={
                          firstNameSort === 'AES'
                            ? 'fas fa-sort-amount-down'
                            : 'fas fa-sort-amount-up'
                        }
                      />
                    </a>
                    First Name
                  </span>
                </div>
              </th>
              <th>
                <div>
                  <span>Last Name</span>
                </div>
              </th>
              <th>
                <div>
                  <span>Phone Numbers</span>
                </div>
              </th>
              <th>
                <div>
                  <span>Device Id</span>
                </div>
              </th>
              <th>
                <div>
                  <span>User Id</span>
                </div>
              </th>
              <th>
                <div>
                  <span>Block Reason</span>
                </div>
              </th>
            </tr>
          </thead>
          <Query
            client={client.clientPrivate}
            query={usersQuery}
            variables={{ input }}
            fetchPolicy="network-only"
          >
            {({ data, loading, error }) => {
              if (loading) {
                return <Loading />;
              }
              if (error) {
                return 'error';
              }

              const { search_stripe_block_users } = data;

              return (
                <View
                  userData={userData}
                  setUserData={setUserData}
                  search_users={search_stripe_block_users}
                  setPageCount={setPageCount}
                  setTotalElements={setTotalElements}
                />
              );
            }}
          </Query>
        </Table>
      </Box>
    </Layout>
  );
};

export default BlockUsers;

const View = ({
  search_users,
  setPageCount,
  setTotalElements,
  userData,
  setUserData,
}) => {
  useEffect(() => {
    setPageCount(search_users.total_pages);
    setTotalElements(search_users.total_size);
    if (search_users.stripe_block_user_listing) {
      setUserData(search_users.stripe_block_user_listing);
    }
  }, [search_users.total_pages]);
  return (
    <tbody>
      {userData.map(user => (
        <ListItem user={user} />
      ))}
    </tbody>
  );
};
